import constants from '../constants.js';


const CtmDebtorsIsEnabled = {
  displayName: 'Is Enabled',
  dataAt: 'IsEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const CtmDebtorsPCC = {
  displayName: 'PCC',
  dataAt: 'Pcc',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const CtmDebtorsHomeCountry = {
  displayName: 'Home Country',
  dataAt: 'HomeCountry',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single',
  required: true
};

const CtmDebtorsLogo = {
  displayName: 'Logo',
  dataAt: 'Logo',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CtmDebtorsTitle = {
  displayName: 'Title',
  dataAt: 'Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const CtmDebtorsIdentifier = {
  displayName: 'Identifier',
  dataAt: 'Id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true,
  minLength: 10
};

const CtmDebtorsAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'CTM Debtor',
  data:
    {
      Id: '',
      Name: '',
      Logo: '',
      HomeCountry: '',
      IsEnabled: false,
    },
  dataAt: '',
  children: [CtmDebtorsIdentifier, CtmDebtorsTitle, CtmDebtorsLogo, CtmDebtorsHomeCountry],
  microService: true,
  endpoint: constants.MICRO_SERVICE.DEBTORS,
};

const CtmDebtorsResource = {
  displayName: 'CTM Debtors',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [CtmDebtorsIdentifier, CtmDebtorsTitle, CtmDebtorsLogo, CtmDebtorsHomeCountry, CtmDebtorsPCC, CtmDebtorsIsEnabled],
  microService: true,
  endpoint: constants.MICRO_SERVICE.DEBTORS,
  iconClass: 'fa-user',
  routeParamId: 'ctmDebtorId'
};



const CtmDebtorsList = {
  rootNode: true,
  displayName: 'CTM Debtors',
  microService: true,
  endpoint: constants.MICRO_SERVICE.DEBTORS,
  iconClass: 'fa-user',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: CtmDebtorsResource, //RailCardsResource,
  gridAdd: CtmDebtorsAddResource, //RailCardsAddResource,
  gridCols:
    [
      {name: 'Identifier', key: 'Id'},
      {name: 'Title', key: 'Name'},
      {name: 'Home Country', key: 'HomeCountry'},
      {name: 'Is Enabled', key: 'IsEnabled'}]
};

export default {
  CtmDebtorsList,
  CtmDebtorsResource,
  CtmDebtorsAddResource,
  CtmDebtorsIdentifier,
  CtmDebtorsTitle,
  CtmDebtorsHomeCountry,
  CtmDebtorsPCC,
  CtmDebtorsIsEnabled
}



// WEBPACK FOOTER //
// ./src/config/fields/ctmDebtors.js